import React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import { styled } from '@mui/system';

import { CHILDREN_PROP_TYPES, MUI_SX_PROP_TYPES } from 'propTypes';
import { BUTTON_COMPONENT_PROPTYPES } from 'bento-ordering/base/constants/propTypes';
import muiPropForwarding from 'styles/helpers/muiPropForwarding';

const SecondaryCtaButton = styled(Button, {
  shouldForwardProp: muiPropForwarding('ownState')
})(({ theme, ownState }) => {
  const ownMuiFooterStyles = ownState?.footer?.(theme) ?? {};
  const ownMuiCartDrawerStyles = ownState?.cartDrawer?.(theme) ?? {};
  const ownHeroSecondaryCtaState = ownState?.heroSecondaryCta?.(theme) ?? {};
  const ownMuiEmptyCartStyles = ownState?.emptyCart?.(theme) ?? {};
  const ownAlertModalStyles = ownState?.alertButton?.(theme) ?? {};

  return {
    textAlign: 'left',
    lineHeight: 1.2,
    padding: 0,
    '&:hover': {
      backgroundColor: 'transparent',
      opacity: '0.7'
    },
    ...ownMuiFooterStyles,
    ...ownMuiCartDrawerStyles,
    ...ownHeroSecondaryCtaState,
    ...ownMuiEmptyCartStyles,
    ...ownAlertModalStyles
  };
});

const SecondaryCta = ({
  handleClick,
  label,
  component,
  href,
  fullWidth,
  to,
  dataTestId,
  disabled = false,
  sx = {},
  ownState = {}
}) => {
  const linkProps = {
    target: '_blank',
    rel: 'noopener noreferrer'
  };

  return (
    <SecondaryCtaButton
      fullWidth={fullWidth}
      component={component}
      onClick={handleClick}
      href={href}
      to={to}
      sx={sx}
      {...(href ? linkProps : {})}
      data-testid={dataTestId}
      ownState={ownState}
      disabled={disabled}
    >
      {label}
    </SecondaryCtaButton>
  );
};

SecondaryCta.defaultProps = {
  fullWidth: false
};
SecondaryCta.propTypes = {
  fullWidth: PropTypes.bool,
  handleClick: PropTypes.func,
  label: CHILDREN_PROP_TYPES,
  classes: PropTypes.shape({}),
  href: PropTypes.string,
  component: BUTTON_COMPONENT_PROPTYPES,
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})]),
  dataTestId: PropTypes.string,
  sx: MUI_SX_PROP_TYPES,
  ownState: PropTypes.object,
  disabled: PropTypes.bool
};

export default SecondaryCta;
